function pathBeforeN(path, n){
	var path = path || "";
	var n = n || 0;
	var output = "";

    var i = 0, len = path.length;
    var counter = 0;
    while (i < len){
    	if (path[i] == "/"){
    		counter++;
    	}
        if ( counter < n){
            output+= path[i];
        }
        else{
            break
        }
        i++;
    }

    return output;
}

export default{
	pathBeforeN
}



// WEBPACK FOOTER //
// ./src/assets/js/pathManager.js